module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_zl_pre.646b4fd1.png";